import styled from "@emotion/styled";

import { BREAKPOINTS } from "../../utils/consts";

const DefaultPopup = (props) => {
  const { img, title, disclaimer } = props;

  return (
    <StyledDefaultPopup>
      <div className="tag">
        <img src={img} className="icon" alt="logo" />
      </div>
      <span className="disclaimer">{disclaimer}</span>
    </StyledDefaultPopup>
  );
};

export default DefaultPopup;

const StyledDefaultPopup = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 586px;
  padding: 48px;
  gap: 48px;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #006e3d;
  background-color: #006e3d;

  @media (max-width: ${BREAKPOINTS.PHONE}px) {
    padding: 16px;
  }

  .tag {
    align-self: flex-start;
    padding: 8px 16px;
    background-image: linear-gradient(
      to right,
      #006e3d 0%,
      rgba(0, 110, 61, 1) 100%
    );
    border-radius: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .icon {
      width: 80%;
    }
  }

  .title {
    font-family: "Roboto Condensed";
    font-size: 38px;
    line-height: 49px;
    font-weight: bold;
    text-transform: uppercase;
    color: #006e3d;
  }

  .subtitle {
    font-family: "Roboto Condensed";
    font-size: 21px;
    line-height: 33px;
    font-weight: 400;
    color: #006e3d;
  }

  .disclaimer {
    font-family: "Roboto Condensed";
    font-size: 21px;
    line-height: 33px;
    font-weight: 800;
    color: #ffffff;
  }
`;
